import React from 'react'
import { MdClose } from 'react-icons/md'
import PropTypes from 'prop-types'
import styles from './toastifyCloseButton.module.scss'

const ToastifyCloseButton = ({ closeToast }) => {
  return (
    <button type="button" className={styles.close} onClick={closeToast}>
      <MdClose color="#4d4d4d" size={20} />
    </button>
  )
}

ToastifyCloseButton.propTypes = {
  closeToast: PropTypes.func.isRequired
}

export default ToastifyCloseButton
